import { getEnvVar } from '@mc/client-env'

const FB_APP_ID = getEnvVar('FACEBOOK_KEY')

type SocialMediaDialogParams = {
  channel?: string
  encodedLink: string
}

const getSocialMediaDialogUrl = ({
  channel = '',
  encodedLink,
}: SocialMediaDialogParams) => {
  const socialMediaDialogUrls = {
    facebook: `https://www.facebook.com/sharer.php?u=${encodedLink}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedLink}`,
    messenger: `https://www.facebook.com/dialog/send?app_id=${FB_APP_ID}&link=${encodedLink}&redirect_uri=${encodedLink}`,
    twitter: `https://twitter.com/intent/tweet?source=webclient&url=${encodedLink}`,
  }

  return channel in socialMediaDialogUrls
    ? socialMediaDialogUrls[channel as keyof typeof socialMediaDialogUrls]
    : undefined
}

export default getSocialMediaDialogUrl
